module.exports = __webpack_public_path__ + "img/ics_o_plus_gray.5b6778ac.svg";